import { render, staticRenderFns } from "./sales-by-fee-type.vue?vue&type=template&id=34d24197&scoped=true&"
import script from "./sales-by-fee-type.vue?vue&type=script&lang=js&"
export * from "./sales-by-fee-type.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34d24197",
  null
  
)

export default component.exports